/* eslint-disable @typescript-eslint/no-var-requires */
import React from 'react';
import { usePlayFlag } from './../../components/topicScroll';

import './animation023.less';

interface IAnimation023Item {
  text: string;
}

interface IAnimation023Props {
  items: IAnimation023Item[];
  className?: string;
  onCompleted?: () => void;
}

const Animation023: React.FunctionComponent<IAnimation023Props> = ({
  items,
  className,
  onCompleted,
}) => {
  const crrRef = React.useRef() as React.MutableRefObject<HTMLDivElement>;
  const playFlag = usePlayFlag(crrRef.current as HTMLElement, '.course-body');
  const [play, setPlay] = React.useState(1);
  const startPlay = (next = 1) => {
    setPlay(next);
    next += 1;
    if (next <= items.length) {
      setTimeout(() => startPlay(next), 2500);
    } else {
      onCompleted && onCompleted();
    }
  };

  React.useEffect(() => {
    if (playFlag) {
      startPlay();
    }
  }, [playFlag]);

  return (
    <div ref={crrRef} className={`animation023 component ${className || ''}`}>
      {items.map((itm: IAnimation023Item, idx: number) => (
        <div key={idx} className="animation023-contaner">
          <div
            className={`animation023-item r${idx + 1} animation ${
              play >= idx + 1 ? 'fade-in' : ''
            }`}
          >
            <img
              src={require(`../../../../../assets/a023-${idx + 1}.png`).default}
              alt=""
            />
            <div
              className="text"
              dangerouslySetInnerHTML={{ __html: itm.text }}
            />
          </div>
        </div>
      ))}
    </div>
  );
};

export default Animation023;
